
export default {
  data() {
    return {
      days: [],
      day: -1,
    };
  },
  head() {
    return {
      title: "Επικοινωνία",
    };
  },
  mounted() {
    this.day = new Date().getDay() - 1;
    if (this.day == 0) {
      this.day = 7;
    }
    for (var day = 5; day <= 11; day++) {
      let d = new Date(1970, 1 - 1, day).toLocaleString("el", {
        weekday: "long",
      });
      this.days.push(d);
    }
  },
};
